var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"pt-4"},[_c('div',{staticClass:"container"},[_c('b-container',{staticClass:"mb-5",attrs:{"fluid":"lg"}},[_c('MapAndDate'),_c('Transportation')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }